import Cookies from 'js-cookie';

const app = {
    state: {
        sidebar: {
            opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
            withoutAnimation: false
        },
        device: 'desktop',
        routerId: 1,
        mapAk: 'qbpRky8G3D3VVqwjpWYpHRB36wKGVBFb',
        cachedViews: [],
        isAdminMenu: "home",
        isFullscreen: false
    },
    mutations: {
        SET_MAPAK: (state, mapAk) => {
            state.mapAk = 'aKdCKLmbavmB1wCKctE7NGupOxiE4NVx';
            // state.mapAk = mapAk;
        },
        ROUTER_ID: (state, id) => {
            state.routerId = id;
        },
        TOGGLE_SIDEBAR: state => {
            state.sidebar.opened = !state.sidebar.opened;
            state.sidebar.withoutAnimation = false;
            if(state.sidebar.opened) {
                Cookies.set('sidebarStatus', 1);
            }else {
                Cookies.set('sidebarStatus', 0);
            }
        },
        CLOSE_SIDEBAR: (state, withoutAnimation) => {
            Cookies.set('sidebarStatus', 0);
            state.sidebar.opened = false;
            state.sidebar.withoutAnimation = withoutAnimation;
        },
        TOGGLE_DEVICE: (state, device) => {
            state.device = device;
        },
        ADD_CACHED_VIEW: (state, route) => {
            if(route.keepAlive && !state.cachedViews.includes(route.name)) {
                state.cachedViews.push(route.name);
            }
            if(state.cachedViews.length > 2) {
                state.cachedViews.shift();
            }
        },
        DEL_CACHED_VIEW: (state, route) => {
            const index = state.cachedViews.findIndex(d => d == route.name);
            if(index != -1) {
                state.cachedViews.splice(index, 1);
            }
        },
        IS_ADMIN_MENU(state, isAdminMenu) {
            state.isAdminMenu = isAdminMenu;
        },
        IS_FULLSCREEN(state, isFullscreen) {
            state.isFullscreen = isFullscreen;
        }
    },
    actions: {
        ToggleSideBar: ({ commit }) => {
            commit('TOGGLE_SIDEBAR');
        },
        CloseSideBar({ commit }, { withoutAnimation }) {
            commit('CLOSE_SIDEBAR', withoutAnimation);
        },
        ToggleDevice({ commit }, device) {
            commit('TOGGLE_DEVICE', device);
        },
        SetRouterId: ({ commit }, id) => {
            commit('ROUTER_ID', id);
        },
        AddCachedView({ commit }, view) {
            const route = {
                name: view.name,
                keepAlive: view.meta.keepAlive
            };
            commit('ADD_CACHED_VIEW', route);
        },
        DelCachedView({ commit }, view) {
            const route = {
                name: view.name,
                keepAlive: view.meta.keepAlive
            };
            commit('DEL_CACHED_VIEW', route);
        },
        SetAdmnMenu({ commit }, isAdminMenu) {
            commit('IS_ADMIN_MENU', isAdminMenu);
        },
        changeFullscreen({ commit }, isFullscreen) {
            commit('IS_FULLSCREEN', isFullscreen);
        },
        SetMapAk({ commit }, ak) {
            commit('SET_MAPAK', ak);
        }
    }
};

export default app;
